/** Testi multilingua */
export const FEATURE_PS_TRANSLATIONS = {
  // ===== BUTTON =====
  search: $localize`:@@common.button.search:Cerca`,
  buttonActions: $localize`:@@common.button.actions:Azioni`,
  buttonSendPS: $localize`:@@ps.button.sendPS:Invia PS`,
  buttonDownloadPS: $localize`:@@ps.button.downloadPS:Scarica file PS`,
  buttonDownloadInvoice: $localize`:@@common.button.downloadInvoice:Scarica ricevuta`,
  buttonSelectReady: $localize`:@@common.button.selectReady:Seleziona pronti`,

  // ===== FIELD =====
  receipt: $localize`:@@ps.field.receipt:Ricevuta`,
  dateFilter: $localize`:@@ps.field.date:Data`,
  profileFilter: $localize`:@@ps.field.profile:Profilo`,
  rowActionCustomerDetail: $localize`:@@ps.field.profileDetail:Dettaglio anagrafica`,
  rowActionFamilyMember: $localize`:@@ps.field.familyDetails:Dettaglio familiari`,
  rowActionReservationDetail: $localize`:@@ps.field.reservationDetail:Dettaglio prenotazione`,
  completeHeader: $localize`:@@ps.field.complete:Completo`,
  stateHeader: $localize`:@@ps.field.state:Stato`,
  nameHeader: $localize`:@@ps.field.name:Cognome e nome`,
  groupMemberHeader: $localize`:@@ps.field.groupMember:Familiari o membri del gruppo`,
  guestsNumberHeader: $localize`:@@ps.field.guestsNumber:Ospiti`,
  roomHeader: $localize`:@@ps.field.room:Camera`,
  noteHeader: $localize`:@@ps.field.note:Note`,

  // ===== STATUS =====
  publicSecurityStatusNotSent: $localize`:@@ps.status.notSent:Non inviato`,
  publicSecurityStatusSentError: $localize`:@@ps.status.sentError:Errore di invio`,
  publicSecurityStatusSentOk: $localize`:@@ps.status.sentOk:Inviato`,
  completeStatus: $localize`:@@ps.status.complete:Completo`,
  incompleteStatus: $localize`:@@ps.status.incomplete:Incompleto`,

  // ===== TOOLTIP =====
  tooltipDownloadInvoice: $localize`:@@ps.tooltip.downloadInvoice:Scarica la ricevuta per gli ospiti inviati. La ricevuta è disponibile dopo mezzanotte e per 30 giorni.`,
  psErrorCode: $localize`:@@ps.tooltip.codeError:Codice errore`,
  psErrorDescription: $localize`:@@ps.tooltip.errorDescription:Descrizione`,
  psErrorDetail: $localize`:@@common.tooltip.detail:Dettaglio`,

  // ===== MESSAGE =====
  toastSendPSCustomerOk: $localize`:@@ps.message.sendPSCustomerOk:Schede PS inviate correttamente`,
  downloadPsReceipt: $localize`:@@ps.message.receiptPS:Scarica la ricevuta per gli ospiti inviati. La ricevuta è disponibile dopo mezzanotte e per 30 giorni.`,

  // ===== VALIDATION =====
  toastSendPSCustomerError: $localize`:@@ps.validation.sendPSCustomerError:Errore durante l'invio delle schede PS`,
  errorsProfileRegistry: $localize`:@@ps.validation.profileRegistryError:Errori nelle anagrafiche`,
  alertNoPublicSecurity: $localize`:@@ps.validation.noPublicSecurity:Non è definito nessun profilo di pubblica sicurezza`,

  errorLoadData: $localize`:@@common.error.loadDataError:Errore durante il caricamento`,

  titleHeader: $localize`:@@ps.title.createPs:Genera schede PS`,
};
